var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedBlogIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".feed-blog-icon_svg__afcls-1{fill:#72166a}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "feed-blog-icon_svg__afcls-1",
  d: "M5 0h14v14H5z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15 0h5v14h-5z",
  style: {
    fill: "#931171"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 0h5v14H4z",
  style: {
    fill: "#5f0f57"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m20 14-8 10-8-10z",
  style: {
    fill: "#e0b9d8"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "feed-blog-icon_svg__afcls-1",
  d: "m8.8 20 3.2 4 3.2-4z"
})));
export default SvgFeedBlogIcon;